import { benefitData } from "store/allData";
import EachBenefit from "./EachBenefit";
import SectionWrapper from "components/common/SectionWrapper";
import Heading from "components/common/Heading";

const Benefits: React.FC = () => {
	return (
		<SectionWrapper className="mx-auto z-20">
			<div
				id="benefits"
				className="flex flex-col items-center mt-32 mb-32 scroll-mt-32"
			>
				<span className="eyebrow">What we do</span>
				<Heading className="text-3xl sm:text-4xl mt-4 text-center">
					Full-stack capabilities
				</Heading>
				<p className="mt-4 max-w-xl text-center text-zinc-400">
					From strategy to shipped product — one team covering design,
					engineering, AI, and blockchain.
				</p>
				<ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 mx-auto mt-14 gap-5">
					{benefitData.map((data) => {
						return <EachBenefit key={data.title} data={data} />;
					})}
				</ul>
			</div>
		</SectionWrapper>
	);
};

export default Benefits;
